import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'

import { QR_PANEL_STATUS } from './constants'
import type { QrTerminalStatus } from './types'

type QrTerminalNoticeProps = {
  status: QrTerminalStatus
}

export const QrTerminalNotice = ({ status }: QrTerminalNoticeProps) => {
  const { t } = useTranslation()

  return (
    <Alert
      showIcon
      type={status === QR_PANEL_STATUS.EXPIRED ? 'warning' : 'error'}
      title={t(`auth.qrSignIn.${status}.title`)}
      description={t(`auth.qrSignIn.${status}.description`)}
    />
  )
}
